export const emptyInitialData = () => ({
  arbol_familiar: [],
});

export const formatMoney = (value, currency) => {
  if (!value) return "";
  const number = parseFloat(String(value).replace(/[^0-9.-]/g, ""));
  if (Number.isNaN(number)) return value;
  return new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: currency && currency.length === 3 ? currency : "MXN",
    maximumFractionDigits: 0,
  }).format(number);
};

export const initials = (name) => (
  name || "?"
).split(" ").map((word) => word[0]).slice(0, 2).join("").toUpperCase();

export const shouldPair = (field, nextField) => {
  if (!nextField) return false;
  const keys = [field.key, nextField.key].join(":");
  if (field.type === "date" && nextField.type === "date") return true;
  return [
    "currency_type:valuation",
    "valuation:currency_type",
    "currency_type:valor_poliza",
    "valor_poliza:currency_type",
    "currency_type:principal",
    "principal:currency_type",
    "valor:moneda",
    "moneda:valor",
    "valor:currency_type",
    "currency_type:valor",
    "tipo_tasa:tasa",
    "participacion:otros_duenos",
    "tipo:cantidad",
    "indemnizacion:prima",
    "nacionalidad:residencia_fiscal",
  ].includes(keys);
};

export const isBlankValue = (value) => (
  value === undefined || value === null || String(value).trim() === "" || value === "__other_holder__"
);

export const getMissingRequiredFields = (fields, values) => (
  fields
    .filter((field) => field.required && isBlankValue(values[field.key]))
    .map((field) => field.key)
);

const normalizeItem = (section, item) => {
  const normalized = { ...item };
  const name = item[section.nameKey] || item.nombre || "";

  if (section.payloadKey === "structures") {
    const structureTypes = {
      Trust: "Trust",
      Fideicomiso: "Trust",
      Corporation: "Corporation",
      Corporacion: "Corporation",
      "Corporación": "Corporation",
    };
    normalized.type = structureTypes[normalized.type || normalized.tipo] || normalized.type || normalized.tipo;
    delete normalized.tipo;
  }

  delete normalized[section.nameKey];
  if (section.nameKey !== "nombre") delete normalized.nombre;
  delete normalized.herederos;

  return {
    name,
    ...normalized,
  };
};

export const buildEstateMappingPayload = (selected, data, order, sections, ownershipStructure) => (
  order.reduce((payload, sectionId) => {
    const section = sections[sectionId];
    payload[section.payloadKey] = selected.includes(sectionId)
      ? (data[sectionId] || []).map((item) => normalizeItem(section, item))
      : [];
    return payload;
  }, {
    selected_sections: selected.map((sectionId) => sections[sectionId].payloadKey),
    ownership_structure: ownershipStructure,
  })
);
